import React, { useCallback, useState, useEffect } from 'react';
import withTranslation from 'hoc/withTranslation';
import styled from '@emotion/styled';
import TerminationCriteriaList from './TerminationCriteriaList';

const StyledTerminationCriteriaContainer = styled.div({
  padding: '1.2rem 0.5rem 0.5rem 0.5rem',
});

const StyledCheckboxWrapper = styled.div({
  display: 'flex',
  alignItems: 'center',
  marginBottom: '1rem',
});

const HiddenCheckbox = styled.input({
  position: 'absolute',
  opacity: 0,
  cursor: 'pointer',
  height: 0,
  width: 0,
});

const StyledCheckboxVisible = styled.div(({ checked }) => ({
  width: '14px',
  height: '14px',
  backgroundColor: '#fff',
  border: '1.5px solid #373d45',
  borderRadius: '2px',
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  transition: 'all 0.2s ease',
  flexShrink: 0,
  '&:hover': {
    borderColor: '#4d89f5',
  },
  '&::after': checked
    ? {
        content: '"✓"',
        color: '#000',
        fontSize: '11px',
        fontWeight: 'bold',
        lineHeight: '1',
      }
    : {},
}));

const StyledLabel = styled.label(({ checked }) => ({
  color: '#fff',
  fontSize: '14px',
  cursor: 'pointer',
  userSelect: 'none',
  display: 'flex',
  alignItems: 'center',
  gap: '0.5rem',
  fontWeight: checked ? '500' : '200',
}));

const TerminationCriteria = ({
  terminationCriteria,
  onChange,
  translations: {
    solverConfigLabels: { terminationCriteriaLabels },
  },
}) => {
  const [enabled, setEnabled] = useState(false);
  useEffect(() => {
    setEnabled(terminationCriteria.enabled);
  }, [terminationCriteria]);

  const handleOnChangeTerminationCriteria = useCallback(
    (newTerminationCriteria) => {
      const toReturn = { enabled, values: newTerminationCriteria };
      onChange(toReturn);
    },
    [onChange, enabled],
  );

  const handleOnSwitchChange = useCallback(
    (e) => {
      const val = e.target.checked;
      setEnabled(val);
      if (onChange) onChange({ enabled: val });
    },
    [onChange],
  );

  return (
    <StyledTerminationCriteriaContainer data-testid="terminationCriteriaToggle">
      <StyledCheckboxWrapper>
        <StyledLabel htmlFor="termination-criteria-enabler" checked={enabled}>
          <StyledCheckboxVisible checked={enabled} />
          <HiddenCheckbox
            type="checkbox"
            id="termination-criteria-enabler"
            checked={enabled}
            onChange={handleOnSwitchChange}
          />
          {terminationCriteriaLabels.switchLabel}
        </StyledLabel>
      </StyledCheckboxWrapper>
      {enabled && (
        <TerminationCriteriaList
          terminationCriteria={terminationCriteria.values}
          onChange={handleOnChangeTerminationCriteria}
        />
      )}
    </StyledTerminationCriteriaContainer>
  );
};

export default withTranslation(TerminationCriteria);
